import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Select from '../../form/Select';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';

function Form({
    token,
    dados,
    setDados,
    empresaId,
    empresaIds,
    handleSubmit,
    btnText,
    caminhoVoltar,
    optionsEmpresa,
    optionsGrupo,
}) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    //Enums
    const [EnumTipo, setEnumTipo] = useState([]);

    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);
        if (table === 'centroCustos') {
            field === 'tipo' && setEnumTipo(result ? result : []);
        }
    };

    useEffect(() => {
        //enum
        consultaEnum('centroCustos', 'tipo', '');
    }, []);

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name === 'limitePadrao') {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }
    async function handleOnBlur(e) {
        const { name, value } = e.target;
        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            //verifica se o centroCusto existe na base de dados
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'centroCusto', value);

            if (duplicidade?.uuid) {
                setFlashMessage('CentroCusto já cadastrado, você será redirecionado para o modo edição!', 'success');
                return navigate(`/CentroCustos/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}
    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Gestão de Centro de Custos</h1>
            <div>
                <SelectEmpresa
                    text="Empresa"
                    name="empresaId"
                    title="Selecione a empresa"
                    options={optionsEmpresa}
                    inputWidth="250px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Input
                    text="Centro de Custo"
                    type="text"
                    name="descricao"
                    placeholder="Nome do centroCusto"
                    title="Digite o nome do centroCusto"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required
                />
                <Select
                    text="Grupo"
                    name="grupoId"
                    title="Selecione o grupo"
                    options={optionsGrupo}
                    inputWidth="250px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.grupoId || ''}
                    required={false}
                    notOptNull={false}
                />
            </div>
            <div>
                <Select
                    name="tipo"
                    title={'Define o tipo do centro de custo'}
                    text="Tipo"
                    options={EnumTipo}
                    handleOnChange={handleChange}
                    value={dados.tipo}
                    isEnum={true}
                    notOptNull={true}
                />
                <InputNumber
                    text="Limite Padrão"
                    type="text"
                    name="limitePadrao"
                    placeholder="Limite"
                    inputWidth="100px"
                    title="digite o limite padrão para acompanhamento do centro de custo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.limitePadrao ? formatarNumero(dados.limitePadrao) : ''}
                    required={false}
                />
                <Checkbox
                    title="Vincula o centro de custo a frota, direcionando o lançamento ao abastecer"
                    text="Combustível"
                    name="combustivel"
                    handleOnChange={handleChange}
                    value={dados.combustivel}
                    checked={!!dados.combustivel}
                />
                <Checkbox
                    title="Restringe o centro de custo a usuários com permissões"
                    text="Restrito"
                    name="restrito"
                    handleOnChange={handleChange}
                    value={dados.restrito}
                    checked={!!dados.restrito}
                />
                <Checkbox
                    title="Informa que esse centro de custo é utilizado para folha de pagamento, direcionando os lançamentos para o módulo de folha"
                    text="Folha de pagamento"
                    name="folhaPagamento"
                    handleOnChange={handleChange}
                    value={dados.folhaPagamento}
                    checked={!!dados.folhaPagamento}
                />
                <Checkbox
                    title="habilita o uso do centro de custo"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <h4>API de Integração</h4>
            <div>
                <Checkbox
                    title="Integração ativa, o objeto será exportado para a API de integração"
                    text="Integração Ativo"
                    name="integracaoAtivo"
                    handleOnChange={handleChange}
                    value={dados.integracaoAtivo}
                    checked={!!dados.integracaoAtivo}
                />
                <Checkbox
                    title="Integração Multi-Empresa, quando marcado o objeto será exportado para a API de integração para todas as empresas do grupo"
                    text="Integração Multi-Empresa"
                    name="integracaoTodasEmpresas"
                    handleOnChange={handleChange}
                    value={dados.integracaoTodasEmpresas}
                    checked={!!dados.integracaoTodasEmpresas}
                />
            </div>
            <div>
                <h4>Vínculados a operações</h4>
                <Checkbox
                    title="Víncula a operações de almoxarifado"
                    text="Almoxarifado"
                    name="almoxarifado"
                    handleOnChange={handleChange}
                    value={dados.almoxarifado}
                    checked={!!dados.almoxarifado}
                />
                <Checkbox
                    title="Víncula a operações de balanço"
                    text="Balanço"
                    name="balanco"
                    handleOnChange={handleChange}
                    value={dados.balanco}
                    checked={!!dados.balanco}
                />
                <Checkbox
                    title="Víncula a operações de caixa"
                    text="Caixa"
                    name="caixa"
                    handleOnChange={handleChange}
                    value={dados.caixa}
                    checked={!!dados.caixa}
                />
                <Checkbox
                    title="Víncula a operações de financeiro"
                    text="Financeiro"
                    name="financeiro"
                    handleOnChange={handleChange}
                    value={dados.financeiro}
                    checked={!!dados.financeiro}
                />
                <Checkbox
                    title="Víncula a operações de entrada no estoque"
                    text="Entrada"
                    name="entrada"
                    handleOnChange={handleChange}
                    value={dados.entrada}
                    checked={!!dados.entrada}
                />
                <Checkbox
                    title="Vincula o centro de custo a industria, utilizado quando o sistema funciona com o modulo de indústria ativo"
                    text="Indústria"
                    name="industria"
                    handleOnChange={handleChange}
                    value={dados.industria}
                    checked={!!dados.industria}
                />
                <Checkbox
                    title="Víncula a operações de lançamentos"
                    text="Lançamentos"
                    name="lancamento"
                    handleOnChange={handleChange}
                    value={dados.lancamento}
                    checked={!!dados.lancamento}
                />
                <Checkbox
                    title="Vincula a locação"
                    text="Locação"
                    name="locacao"
                    handleOnChange={handleChange}
                    value={dados.locacao}
                    checked={!!dados.locacao}
                />
                <Checkbox
                    title="Vincula a operações de logística"
                    text="Logística"
                    name="logistica"
                    handleOnChange={handleChange}
                    value={dados.logistica}
                    checked={!!dados.logistica}
                />
                <Checkbox
                    title="Vincula o centro de custo a manutenção, utilizado quando o sistema funciona com o modulo de manutenção ativo"
                    text="Manutenção"
                    name="manutencao"
                    handleOnChange={handleChange}
                    value={dados.manutencao}
                    checked={!!dados.manutencao}
                />
                <Checkbox
                    title="Víncula a operações de movimentos no estoque genérico"
                    text="Movimentos"
                    name="movimento"
                    handleOnChange={handleChange}
                    value={dados.movimento}
                    checked={!!dados.movimento}
                />
                <Checkbox
                    title="Víncula a operações de saída no estoque"
                    text="Saída"
                    name="saida"
                    handleOnChange={handleChange}
                    value={dados.saida}
                    checked={!!dados.saida}
                />
                <Checkbox
                    title="Vincula o centro de custo a um serviço"
                    text="Serviço"
                    name="servico"
                    handleOnChange={handleChange}
                    value={dados.servico}
                    checked={!!dados.servico}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
